import axios from "axios";
//brand api
const BaseUrl = 'https://manager.atyourdoormobilerepairs.com/api';
//const BaseUrl = 'http://192.168.29.132:1300/api';

const BrandData = async () =>{

  const url = BaseUrl + '/getapi/getAllBrand'
  try {
    const response = await axios.get(url);
    return response;
  } catch (error) {
    console.error('Fetch error:', error);
    return null; 
  }
};

//get reviews
const GetReviews = async (id) => {
  const url = BaseUrl + '/getapi/getReviews' 
  try {
    const response = await axios.get(url)
    return response;

  } catch (error) {
    console.error('Fetch error:', error);
    return null; 
  }
}

const GetAllModels = async (token) => {
  const url = BaseUrl + '/postapi/getAllModel' 
  try {
    const response = await axios.post(url,{token:token})
    return response;

  } catch (error) {
    console.error('Fetch error:', error);
    return null; 
  }
}

const GetAllColor = async (token) => {
  const url = BaseUrl + '/postapi/getAllColor' 
  try {
    const response = await axios.post(url,{token:token})
    return response;

  } catch (error) {
    console.error('Fetch error:', error);
    return null; 
  }
}

const GetInventory = async (product_token) => {
  const url = BaseUrl + '/postapi/getInventory';
  try {
    const result = await axios.post(url,  product_token );
    return result.data;  
  } catch (error) {
    console.log("Error fetching inventory:", error.response ? error.response.data : error.message);
    throw error;
  }
};

const GetOtp = async (phone) => {
  const url = BaseUrl + '/postapi/getOtp';
  try {
    const result = await axios.post(url,{phone});
    return result.data;
  } catch (error) {
    console.error("Error fetching otp:", error.response ? error.response.data : error.message);
    return null;
  }
};


const GetOtpVerify = async (contact,otp) => {
  const url = BaseUrl + '/postapi/verifyOtp';
  try {
    const result = await axios.post(url,{contact,otp});
    return result.data;
  } catch (error) {
    console.error("Error fetching otp:", error.response ? error.response.data : error.message);
    return null;
  }
};

const signUpNewUser = async (userData) => {
  console.log(userData)
  const url = BaseUrl + '/postapi/custSignup';
  // console.log("cust_no",userData.cust_contact)
  try {
    const result = await axios.post(url,userData);
    return result.data;
  } catch (error) {
    console.error("Error fetching otp:", error.response ? error.response.data : error.message);
    return null;
  }
};

const AddAddress = async (data) => {
  const url = BaseUrl + '/postapi/addAddress';
  // console.log("cust_no",userData.cust_contact)
  try {
    const result = await axios.post(url,data);
    
    return result.data;
  } catch (error) {
    console.error("Error fetching address:", error.response ? error.response.data : error.message);
    return null;
  }
};

const GetAddress = async (data) => {
  const url = BaseUrl + '/postapi/getAddress';
  // console.log("cust_no",userData.cust_contact)
  try {
    const result = await axios.post(url,data);  
    return result.data;
  } catch (error) {
    console.error("Error fetching address:", error.response ? error.response.data : error.message);
    return null;
  }
};
const DeleteAddress = async (data) => {
  const url = BaseUrl + '/postapi/deleteAddress';
  // console.log("cust_no",userData.cust_contact)
  try {
    const result = await axios.post(url,data);   
    return result.data;
  } catch (error) {
    console.error("Error fetching address:", error.response ? error.response.data : error.message);
    return null;
  }
};

const CreateOrder = async (data) => {
  const url = BaseUrl + '/postapi/placeOrder';
  try {
    const result = await axios.post(url,data);    
    return result.data;
  } catch (error) {
    console.error("Error fetching cart:", error.response ? error.response.data : error.message);
    return null;
  }
};

const GetCart = async (token) => {
  const url = BaseUrl + '/postapi/showCart';
  try {
    const result = await axios.post(url,token);
    return result.data;
  } catch (error) {
    console.error("Error fetching cart:", error.response ? error.response.data : error.message);
    throw error;
  }
};

const EditCart = async (token) => {
  const url = BaseUrl + '/postapi/editCart';
  try {
    const result = await axios.post(url,token);
    return result.data;
  } catch (error) {
    console.error("Error fetching cart:", error.response ? error.response.data : error.message);
    throw error;
  }
};

const GetCustomer = async (cust_token) => {
  const url = BaseUrl + '/postapi/getCustomer';
  try {
    const result = await axios.post(url,cust_token);
    return result.data;
  } catch (error) {
    console.error("Error fetching customer", error.response ? error.response.data : error.message);
    throw error;
  }
};

const OnlinePayment = async (data) =>{
  const url = BaseUrl + `/postapi/onlinePayment`;
  try {
    const response = await axios.post(url,data);
    return response.data;
  } catch (error) {
    console.log('error in online pay: ', error);
    throw error;
  }
}

const VerifyPay = async (paymentData) => {
  const url = BaseUrl + `/postapi/verifypay`;
  try {
    const result = await axios.post(url, paymentData);
    return result.data;
  } catch (error) {
    console.log('error verifying: ', error);
    throw error;
  }
};

const RequestDevice = async (data) => {
  const url = BaseUrl + `/postapi/requestDevice`;
  try {
    const result = await axios.post(url, data);
    return result.data;
  } catch (error) {
    console.log('error verifying: ', error);
    throw error;
  }
};

const getAllOrderHistory = async (data) => {
  const url = BaseUrl + `/postapi/getCustOrders`;
  try {
    const result = await axios.post(url, data);
    return result.data;
  } catch (error) {
    console.log('error verifying: ', error);
    throw error;
  }
};

const EditProfile = async (data) => {
  const url = BaseUrl + `/postapi/EditCustomer`;
  try {
    const result = await axios.post(url, data);

    return result.data;
  } catch (error) {
    console.log('error verifying: ', error);
    throw error;
  }
};

const ViewOrderDetails = async (data) => {
  const url = BaseUrl + `/postapi/getOrder`;
  try {
    const result = await axios.post(url, data);
    return result.data;
  } catch (error) {
    console.log('error verifying: ', error);
    throw error;
  }
};

const CancelOrder = async (data) => {
  const url = BaseUrl + `/postapi/cancelOrder`;
  try {
    const result = await axios.post(url, data);
    return result.data;
  } catch (error) {
    console.log('error verifying: ', error);
    throw error;
  }
};

const getCoupon = async (data) => {
  const url = BaseUrl + `/postapi/getCoupon`;
  try {
    const result = await axios.post(url, data);
    return result.data;
  } catch (error) {
    console.log('error verifying: ', error);
    throw error;
  }
};

const getWebCarousel = async () => {
  const url = BaseUrl + `/getapi/getWebCarousel`;
  try {
    const result = await axios.get(url);
    return result.data;
  } catch (error) {
    console.log('error verifying: ', error);
    throw error;
  }
};


const PaymentMethod = async (data) => {
  const url = BaseUrl + `/postapi/paymentMethod`;
  try {
    const result = await axios.post(url,data);
    return result.data;
  } catch (error) {
    console.log('error verifying: ', error);
    throw error;
  }
};

//getWebCarousel

export { BrandData,GetReviews,GetAllModels,GetAllColor,GetInventory,GetOtp,GetOtpVerify,signUpNewUser,AddAddress ,GetAddress,DeleteAddress,CreateOrder,GetCart,GetCustomer,OnlinePayment,VerifyPay,EditCart,RequestDevice,getAllOrderHistory,EditProfile,ViewOrderDetails,CancelOrder,getCoupon,getWebCarousel,PaymentMethod}
